import React, { useEffect, useState } from 'react';
import { GAME_STATUS_WON } from '../../actions/game';
import { playSound } from '../../utils/audio-helper';
import './index.css';

const CRLandingScreen = props => {

	const { transitionOut, status, points, sounds } = props,
		[isWinner, setIsWinner] = useState(status===GAME_STATUS_WON),
		[isTopScorer, setIsTopScorer] = useState(status===GAME_STATUS_WON && points>=1000),
		resultClassName = (isWinner ? 'won':'lost'),
		resultMessage = (isTopScorer && 'Top Score!') || (isWinner && 'You Won!') || 'Nice Try!',
		handleAnimationEnd = evt => {
			const { animationName } = evt;

			if (animationName === 'scrolling-bg') {
			transitionOut();
			} 
		}

	useEffect(()=>{
		if (isWinner) {
			playSound(sounds, 'winning');
		} else {
			playSound(sounds, 'end_theme');
		}
	},[]);

	return (
		<div className={"cr-result " + resultClassName} onAnimationEnd={handleAnimationEnd}>
			<div className="game-status">
				<div className="result-message">
				{resultMessage}
				</div>
				<a className="replay-btn" onClick={transitionOut}>Play Again</a>
				<div className="cr-result-host"></div>
			</div>
			<div className="external-panel">
				<div className="cr-result-logo"><gsntv-wc-tune-in show-id="chain-reaction"></gsntv-wc-tune-in></div>
				<a className="external-btn" target="_blank" href="https://watch.gameshownetwork.com/channels/c6f0faf0-6555-11ea-b686-2f0e735e3aab/play?utm_source=main_site&utm_medium=CR_Webgame&utm_campaign=EndScreen_Ad">Watch a Free Episode</a>
				<a className="external-btn" target="_blank" href="https://www.gameshownetwork.com/games">Play More Games</a>
			</div>
		</div>
	)
}

export default CRLandingScreen;


// WEBPACK FOOTER //
// ./src/components/CRResultScreen/index.jsx